export default __webpack_public_path__ + "static/media/multi-sensory-design.32839b2e.svg";